import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from 'material-ui/Button';
import Dialog, {
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
} from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import validate from 'validate.js';
import isEmpty from 'lodash/isEmpty';
import * as userActions from '../user.actions';
import { withStyles } from 'material-ui/styles/index';
const constraints = {
  email: {
    email: true,
  },
};

const styles = theme => ({
  input: {
    width: '100%',
  },
});

class ForgotPasswordDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      errors: {},
      isValid: false,
      touched: false,
      isOpen: true,
    };
  }

  handleClose = () => {
    this.props.onRequestClose();
  };
  handleChange = () => {
    const { forgotPassword } = this.props;
    forgotPassword({ email: this.state.email }).then(action => {
      this.setState({
        submitted: true,
      });
    });
  };

  validate = () => {
    const { email } = this.state;
    const errors =
      validate({ email }, constraints, {
        format: 'custom',
      }) || {};
    const isValid = isEmpty(errors);
    this.setState({
      errors,
      isValid,
    });
  };
  onInputChange = event => {
    this.setState(
      {
        email: event.target.value,
      },
      () => {
        this.validate();
      }
    );
  };
  onBlur = event => {
    this.setState({
      touched: true,
    });
    this.validate();
  };

  render() {
    const { classes } = this.props;
    const { isValid, errors, touched, isOpen } = this.state;
    return (
      <Dialog onRequestClose={this.handleRequestClose} open={isOpen}>
        <DialogTitle>Palauta salasana</DialogTitle>
        {!this.state.submitted ? (
          <div>
            <DialogContent>
              <DialogContentText>
                Syötä alle sähköpostisi, niin lähetämme ohjeet salasanan
                palauttamiseen.
              </DialogContentText>
              <TextField
                name="email"
                label="Sähköposti"
                type="email"
                autoComplete="off"
                margin="normal"
                className={classes.input}
                onBlur={this.onBlur}
                error={errors['email'] && touched}
                onChange={this.onInputChange}
                value={this.state.password}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} color="primary">
                Peruuta
              </Button>
              <Button
                disabled={!isValid}
                onClick={this.handleChange}
                color="primary"
              >
                Palauta salasana
              </Button>
            </DialogActions>
          </div>
        ) : (
          <div>
            <DialogContent>
              <DialogContentText>
                Tarkasta sähköpostisi – Lähetimme ohjeet salasanan
                palauttamiseen.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} color="primary">
                OK
              </Button>
            </DialogActions>
          </div>
        )}
      </Dialog>
    );
  }
}
export default connect(null, Object.assign({}, userActions))(
  withStyles(styles)(ForgotPasswordDialog)
);



// WEBPACK FOOTER //
// ./src/modules/user/components/ForgotPasswordDialog.js